module.exports = __webpack_public_path__ + "static/screen6-30a081a04002bd3349281e57fa42b8ed.webp";